import { env } from './env.js';

export const API_BASE_URL = env.VITE_API_BASE_URL;
export const PUBLIC_BASE_URL = env.VITE_PUBLIC_BASE_URL;

// IAM handoff login
export const AUTH_API_URL = env.VITE_AUTH_API_URL;
export const AUTH_FRONTEND_URL = env.VITE_AUTH_FRONTEND_URL;
export const PROJECT_SLUG = env.VITE_PROJECT_SLUG;

/**
 * The canonical hostname (no port) for this app. Any other hostname at runtime is treated
 * as a custom domain that resolves its tenant/league context from the API.
 */
export const CANONICAL_HOST = env.VITE_CANONICAL_HOST;

export const MAX_UPLOAD_BYTES = 2 * 1024 * 1024; // 2 MB

export const ROUTES = {
  home: '/',
  league: (id: string) => `/ligas/${id}`,
  equipoFixture: (leagueId: string, teamId: string) => `/ligas/${leagueId}/equipos/${teamId}/fixture`,
  login: '/login',
  admin: '/admin',
  adminLeagues: '/admin/ligas',
  adminLeagueNew: '/admin/ligas/nueva',
  adminLeague: (id: string) => `/admin/ligas/${id}`,
  adminFixture: (leagueId: string, divisionId: string) =>
    `/admin/ligas/${leagueId}/divisiones/${divisionId}/fixture`,
  adminResultados: (leagueId: string, divisionId: string) =>
    `/admin/ligas/${leagueId}/divisiones/${divisionId}/resultados`,
  adminFinales: (leagueId: string, divisionId: string) =>
    `/admin/ligas/${leagueId}/divisiones/${divisionId}/finales`,
  adminDomains: '/admin/dominios',
} as const;
